import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import LoadingButton from "../../components/LoadingButton";
import EmailTemplateEditor from "../../components/EmailTemplateEditor";
import { hostname } from "../../utils";

export default ({
  open,
  onClose,
  execution,
  companyId,
  getToken,
}: {
  open: boolean;
  onClose: () => void;
  execution: any;
  companyId: string;
  getToken: () => Promise<string>;
}) => {
  const [loading, setLoading] = useState(false);
  const [editExecution, setEditExecution] = useState<any>({});

  const handleClose = () => {
    setEditExecution({});
    onClose();
  };

  const saveExecution = async () => {
    setLoading(true);
    const currentToken = await getToken();
    axios
      .post(
        `${hostname}/sequences/${editExecution.sequenceId}/executions/${editExecution.id}`,
        {
          execution: editExecution,
          companyId,
        },
        {
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        }
      )
      .then(() => {
        handleClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (execution) {
      setEditExecution(execution);
    }
  }, [execution]);

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
      <DialogTitle>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6">Message Editor</Typography>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <TextField
          sx={{ mt: 2, mb: 2 }}
          fullWidth
          value={editExecution.subject || ""}
          onChange={(e) =>
            setEditExecution({ ...editExecution, subject: e.target.value })
          }
          label="Subject"
        />
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Body
        </Typography>
        <EmailTemplateEditor
          value={editExecution.content || ""}
          onChange={({ content }) => {
            if (content !== undefined) {
              setEditExecution({ ...editExecution, content });
            }
          }}
          height={400}
          enableVariables={false}
          enableTemplates={false}
          enableInsertMenu={false}
          enableAIGenerate={false}
          enableSpintax={false}
          enableAISnippet={false}
          enableSpamChecker={false}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={loading}
          onClick={saveExecution}
        >
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
